export default __webpack_public_path__ + "content/media/IcoTelefono.f44c7f40.svg";